module.exports = __webpack_public_path__ + "img/icon-default.svg";